import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { CommonHelper } from 'src/utils/commonHelper';
import CRMAccounts from './crm-accounts/crm.accounts';
import CRM from './crm.component';

const CRMInfoComponent = () => {
  const { t: translate } = useTranslation();
  const [currentTab, setCurrentTab] = useState('crm');
  const location = useLocation();
  const isCustomDomain = CommonHelper.CustomDomain();
  const isShowOfferBanner = CommonHelper.ShowOfferBanner();
 const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");

  useEffect(() => {
    if (location.state?.data) {
      setCurrentTab(location.state?.data);
    }
  });
  const ACCOUNT_TABS = [
    {
      value: 'crm',
      icon: <AccountBoxSharpIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <CRM handleNavCRMAccounts={() => setCurrentTab('crm-accounts')} />,
      label: translate('crm.tabs.crm'),
    },
    {
      value: 'crm-accounts',
      icon: <ManageAccountsIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <CRMAccounts isShowOfferBanner={isShowOfferBanner}/>,
      label: translate('crm.tabs.webhook_accounts'),
    },
  ];
  return (
    <>
      <Helmet>
        <title>{translate('crm.social_crm_title')}</title>
      </Helmet>
      <Tabs
        value={currentTab}
        scrollButtons="auto"
        variant="scrollable"
        sx={{ gap: '0.5rem', minHeight: '37px' }}
        allowScrollButtonsMobile
        onChange={(e, value) => setCurrentTab(value)}
      >
        {ACCOUNT_TABS.map((tab) => {
          return (
            <Tab
              sx={{
                flexDirection: 'row',
                gap: '0.25rem',
                padding: 0,
                minHeight: '10px',
                mr: '0.75rem',
                fontWeight: 600,
              }}
              disableRipple
              key={tab.value}
              label={tab.label}
              icon={tab.icon}
              value={tab.value}
            />
          );
        })}
        {(!isCustomDomain || isPortalAdmin) && (
          <Button
            variant="outlined"
            startIcon={<YouTubeIcon />}
            onClick={() => window.open('https://www.youtube.com/watch?v=_scH4MrZtgc', '_blank')}
            color="primary"
          >
            {translate('common.tutorial')}
          </Button>
        )}
      </Tabs>
      <Box sx={{ mb: 2 }} />
      {ACCOUNT_TABS.map((tab) => {
        const isMatched = tab.value === currentTab;
        return isMatched && <Box key={tab.value}>{tab.component}</Box>;
      })}
    </>
  );
};
export default CRMInfoComponent;
